import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api, type AlertRow } from "../api.ts";
import { fmtDateTime } from "../lib/format.ts";

export function AlertsPage() {
  const { slug } = useParams<{ slug: string }>();
  const [alerts, setAlerts] = useState<AlertRow[]>([]);
  const [showAck, setShowAck] = useState(false);

  const load = async () => {
    const d = await api.get<{ alerts: AlertRow[] }>(`/api/t/${slug}/alerts?unack=${!showAck}&limit=200`);
    setAlerts(d.alerts);
  };
  useEffect(() => { load(); }, [slug, showAck]);

  const ack = async (id: number) => {
    await api.post(`/api/t/${slug}/alerts/${id}/ack`);
    load();
  };

  return (
    <>
      <div className="section-head">
        <div>
          <p className="eyebrow">Operacional</p>
          <h1>Alertas</h1>
        </div>
        <label style={{ display: "inline-flex", alignItems: "center", gap: ".4rem", fontSize: ".88rem" }}>
          <input type="checkbox" checked={showAck} onChange={(e) => setShowAck(e.target.checked)} />
          incluir resolvidos
        </label>
      </div>
      <div className="card">
        {alerts.length === 0 ? (
          <p style={{ color: "var(--text-muted)" }}>nenhum alerta {showAck ? "" : "pendente"}.</p>
        ) : alerts.map((a) => (
          <div key={a.id} className="list-row" style={{ alignItems: "flex-start" }}>
            <span style={{ flex: 1 }}>
              <span className={`pill ${a.severity === "critical" ? "red" : a.severity === "warning" ? "amber" : ""}`} style={{ marginRight: ".5rem" }}>
                {a.severity}
              </span>
              <strong>{a.title}</strong>
              {a.source && <span className="mono" style={{ marginLeft: ".5rem", opacity: .55, fontSize: ".78rem" }}>{a.source}</span>}
              {a.detail && <div style={{ color: "var(--text-soft)", fontSize: ".85rem", marginTop: ".2rem" }}>{a.detail}</div>}
              <div className="mono" style={{ fontSize: ".72rem", opacity: .55, marginTop: ".3rem" }}>{fmtDateTime(a.created_at)}</div>
            </span>
            {!a.acknowledged_at && (
              <button className="btn small secondary" onClick={() => ack(a.id)}>marcar resolvido</button>
            )}
          </div>
        ))}
      </div>
    </>
  );
}
